<template>
    <span
        class="request-priority-badge"
        :class="{ 'request-priority-badge_unknown': !style }"
        :style="badgeStyle"
        :title="label"
        :aria-label="`Приоритет: ${label}`"
        >{{ title }}</span
    >
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { priorityLabel, priorityStyle, priorityTitle } from '@/js/requestPriority';

/**
 * Метка приоритета обращения: текст P1–P4 всегда виден, цвет только дополняет его.
 */
@Component
class RequestPriorityBadge extends Vue {
    @Prop({ type: Number, default: null })
    priority;

    get title() {
        return priorityTitle(this.priority);
    }

    get label() {
        return priorityLabel(this.priority);
    }

    get style() {
        return priorityStyle(this.priority);
    }

    get badgeStyle() {
        return this.style ? { color: this.style.color, background: this.style.background } : null;
    }
}

export default RequestPriorityBadge;
</script>
<style lang="scss">
.request-priority-badge {
    display: inline-block;
    min-width: 28px;
    padding: 0 6px;
    border-radius: 6px;
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 20px;
    text-align: center;
    white-space: nowrap;

    &_unknown {
        color: #808080;
    }
}
</style>
